import { isDemoAccount } from './demoAccounts';

interface MaybeReadOnlyAccount {
  id: number;
  isDemo?: boolean;
  readOnly?: boolean;
}

/**
 * True for an own artist above the artist limit of the plan. The demo artist is read-only too,
 * but it has its own tag and notice, so it is left out here.
 */
export function isReadOnlyAccount(account: MaybeReadOnlyAccount | null | undefined): boolean {
  return account?.readOnly === true && !isDemoAccount(account);
}
